export const SET_GIORNATE = 'SET_GIORNATE';
export const SET_GIORNATE_PAGEABLE = 'SET_GIORNATE_PAGEABLE';
export const SET_GIORNATE_LIST = 'SET_GIORNATE_LIST';
export const SET_TIPOLOGIA_GIORNATA = 'SET_TIPOLOGIA_GIORNATA';
